import React from "react";

import { formatDateBR, normalizeStatus } from "./helpers";

/** "Resolvida em dd/mm/aaaa por Nome" (sem nome: só a data). Nada se não resolvida. */
const ResolvedInfo = ({ occurrence, className }) => {
  if (!occurrence || normalizeStatus(occurrence.status) !== "resolvida" || !occurrence.resolvedAt) return null;
  return (
    <div className={className}>
      Resolvida em {formatDateBR(occurrence.resolvedAt)}
      {occurrence.resolvedByName ? ` por ${occurrence.resolvedByName}` : ""}
    </div>
  );
};

export default ResolvedInfo;
